import { createFeatureSelector, createSelector } from '@ngrx/store';

import { userNotificationsFeatureKey } from './user-notifications.reducers';
import { IUserNotificationsState } from './user-notifications.state';

export const selectUserNotificationsState =
	createFeatureSelector<IUserNotificationsState>(userNotificationsFeatureKey);

export const selectUserNotificationItems = createSelector(
	selectUserNotificationsState,
	state => state?.items ?? []
);

export const selectUserNotificationsTotalCount = createSelector(
	selectUserNotificationsState,
	state => state?.totalCount ?? 0
);

export const selectUserNotificationsUnreadCount = createSelector(
	selectUserNotificationsState,
	state => state?.unreadCount ?? 0
);

export const selectUserNotificationsHasRead = createSelector(
	selectUserNotificationsState,
	state => (state?.totalCount ?? 0) - (state?.unreadCount ?? 0) > 0
);

export const selectUserNotificationsLoading = createSelector(
	selectUserNotificationsState,
	state => state?.loading ?? false
);
